<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                  <FormPsicotecnico></FormPsicotecnico>
            </div>
        </div>
    </div>
</template>

<script>
import FormPsicotecnico from './FormPsicotecnico'
export default {
  name: 'form-paciente-cadastro',
  components: {
    FormPsicotecnico
  }
}
</script>
